import { Menu } from '@mantine/core';
import { Icon, IconButton } from '@repo/foundations';
import { memo } from 'react';

export const ReplyMenu = memo(
	({
		onEdit,
		onDelete,
		className,
	}: {
		onEdit?: () => void;
		onDelete: () => void;
		className?: string;
	}) => (
		<Menu shadow="md" position="left-start">
			<Menu.Target>
				<IconButton
					iconName="dots"
					variant="tertiary"
					tooltip="More actions"
					className={className}
				/>
			</Menu.Target>
			<Menu.Dropdown>
				{onEdit && (
					<Menu.Item icon={<Icon name="pencil" />} onClick={onEdit}>
						Edit
					</Menu.Item>
				)}
				<Menu.Item icon={<Icon name="trash" />} onClick={onDelete}>
					Delete...
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	)
);
